import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Home() {
  const navigate = useNavigate();

  const [lang, setLang] = useState("en");
  const [video, setVideo] = useState(null);

  useEffect(() => {
    fetch(
      `https://mocktest.bbmclasses.com/api/get_mocktest_video.php?lang=${lang}`
    )
      .then((res) => res.json())
      .then((data) => setVideo(data));
  }, [lang]);

  const getEmbedUrl = (url) => {
    if (!url) return "";

    if (url.includes("/shorts/")) {
      const id = url.split("/shorts/")[1].split("?")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    if (url.includes("youtu.be/")) {
      const id = url.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    if (url.includes("watch?v=")) {
      const id = url.split("watch?v=")[1].split("&")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    if (url.includes("/embed/")) {
      return url.split("?")[0];
    }

    return "";
  };

  return (
    <>
      <Header />

      <div style={styles.page}>
        {/* HERO */}
        <div style={styles.hero}>
          <h1 style={styles.title}>Welcome to BBM Classes</h1>
          <p style={styles.subtitle}>
            Your trusted learning platform for <b>Bihar Board</b> and{" "}
            <b>Competitive Exams</b>
          </p>

          <p style={styles.desc}>
            We believe quality education should be <b>accessible to everyone</b>.
            That’s why BBM Classes provides <b>100% FREE</b> mock tests, practice
            material, and detailed solutions in <b>Hindi & English</b>.
          </p>
        </div>

        {/* FEATURES */}
        <div style={styles.features}>
          <div>✔ Previous Years Questions</div>
          <div>✔ Chapter & Section-wise Tests</div>
          <div>✔ Full Mock Test Series</div>
          <div>✔ Detailed Solutions</div>
        </div>

        {/* CARDS */}
        <div style={styles.cardRow}>
          <div style={styles.card} onClick={() => navigate("/subjects")}>
            <div style={styles.icon}>📘</div>
            <h3>Solutions</h3>
            <p>Chapter & exam-wise solutions.</p>
            <button style={styles.btn}>Open</button>
          </div>

          <div style={styles.card} onClick={() => navigate("/subject")}>
            <div style={styles.icon}>📝</div>
            <h3>Mock Tests</h3>
            <p>Real exam pattern tests.</p>
            <button style={styles.btn}>Start</button>
          </div>
        </div>

        {/* TRUST */}
        <div style={styles.trustBox}>
          <h3>Why BBM Classes?</h3>
          <p>
            We focus on <b>concept clarity</b>, not shortcuts. All content is{" "}
            <b>FREE</b>. Premium courses may come later, but free learning will
            always stay.
          </p>
        </div>
      </div>

      {/* VIDEO SECTION */}
      <div style={{ padding: 16, paddingBottom: 100 }}>
        {video && (
          <>
            <div style={styles.titleRow}>
              <h3 style={styles.videoTitle}>{video.title}</h3>

              {/* LANGUAGE TABS */}
              <div style={styles.langTabs}>
                <button
                  onClick={() => setLang("en")}
                  style={{
                    ...styles.langTab,
                    ...(lang === "en" ? styles.activeLangTab : {}),
                  }}
                >
                  English
                </button>

                <button
                  onClick={() => setLang("hi")}
                  style={{
                    ...styles.langTab,
                    ...(lang === "hi" ? styles.activeLangTab : {}),
                  }}
                >
                  हिन्दी
                </button>
              </div>
            </div>

            {/* RESPONSIVE VIDEO */}
            <div style={styles.videoWrapper}>
              <iframe
                src={getEmbedUrl(video.youtube)}
                title="Mock Test Tutorial"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
                style={styles.iframe}
              />
            </div>
          </>
        )}
      </div>

      <Footer />
    </>
  );
}

/* ================= STYLES ================= */

const styles = {
  page: {
    minHeight: "100vh",
    background: "rgba(255,255,255,0.08)",
    backdropFilter: "blur(8px)",
    border: "1px solid rgba(255,255,255,0.15)",
  },

  hero: {
    textAlign: "center",
    padding: "30px 20px",
    maxWidth: 900,
    margin: "auto",
  },

  title: { fontSize: 26, marginBottom: 10 },
  subtitle: { fontSize: 16, opacity: 0.9 },
  desc: { fontSize: 15, lineHeight: 1.6, opacity: 0.85 },

  features: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px,1fr))",
    gap: 10,
    maxWidth: 900,
    margin: "20px auto",
    padding: "0 20px",
  },
  cardRow: {
  display: "flex",
  gap: 15,
  justifyContent: "center",
  padding: 20,
  flexWrap: "nowrap",
  overflowX: "auto",
},

  card: {
    background: "#fff",
    color: "#000",
    width: 160,
    padding: 16,
    borderRadius: 12,
    textAlign: "center",
    cursor: "pointer",
    boxShadow: "0 8px 22px rgba(0,0,0,.35)",
  },

  icon: { fontSize: 36 },
  btn: {
    marginTop: 10,
    padding: "6px 14px",
    background: "#22c55e",
    border: "none",
    borderRadius: 20,
    fontWeight: "bold",
    cursor: "pointer",
  },

  trustBox: {
    maxWidth: 900,
    margin: "30px auto",
    padding: 20,
    background: "rgba(255,255,255,0.05)",
    borderRadius: 12,
  },

  titleRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
    marginBottom: 10,
  },

  videoTitle: { fontSize: 18, fontWeight: "bold" },

  langTabs: {
    display: "flex",
    gap: 8,
    background: "#f3f4f6",
    padding: 4,
    borderRadius: 999,
  },

  langTab: {
    padding: "6px 16px",
    border: "none",
    borderRadius: 999,
    background: "transparent",
    cursor: "pointer",
    fontWeight: 600,
  },

  activeLangTab: {
    background: "#22c55e",
  },

  videoWrapper: {
    position: "relative",
    paddingTop: "56.25%",
    borderRadius: 12,
    overflow: "hidden",
    background: "#000",
  },

  iframe: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    border: "none",
  },
};